import { mutatorAction } from 'satcheljs';
import store from '../store/Store';

/**
 * Action to update the page origin in the store.
 */
export default mutatorAction('SET_PAGE_ORIGIN', function setPageOrigin(pageOrigin: string) {
    store.pbpPublishingSetting.publishingSettings.PageOrigin = pageOrigin;
});
